// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckBox_checkbox__3tiD0","checkboxContainer":"CheckBox_checkboxContainer__UI2fK","input":"CheckBox_input__FHP3K","showmore":"CheckBox_showmore__+WDu6"};